import { mockNotifications } from '@/mock/misc';
import type { Notification } from '@/types';

const delay = (ms = 250) => new Promise((r) => setTimeout(r, ms));

export const notificationService = {
  async listForUser(userId: string): Promise<Notification[]> {
    await delay();
    return mockNotifications
      .filter((n) => n.userId === userId)
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  },
  async unreadCount(userId: string): Promise<number> {
    await delay(100);
    return mockNotifications.filter((n) => n.userId === userId && !n.read).length;
  },
  async markRead(id: string): Promise<void> {
    await delay(80);
    const n = mockNotifications.find((x) => x.id === id);
    if (n) n.read = true;
  },
  async markAllRead(userId: string): Promise<void> {
    await delay(120);
    for (const n of mockNotifications) {
      if (n.userId === userId) n.read = true;
    }
  },
};
